// import "jquery";

export default {
  init() {
    const _ = this;

    _.fix();
  },
  fix() {
    const addToCartButton = document.querySelector('.quantity + .single_add_to_cart_button');
    if (addToCartButton) {
      const container = addToCartButton.previousElementSibling;
      container.classList.add('has-button');
      container.append(addToCartButton);
    }
  },
};



// WEBPACK FOOTER //
// /Users/dcsturm/wrk/packages/composer/zd-wp-sage-lib/resources/assets/scripts/routes/woocommerce.js